module.exports = "<div class=modal-header><h4 class=modal-title l10n=\"\">We're experiencing a problem</h4></div><div class=\"modal-body bg-danger\"><p><span l10n=\"\">A unexpected error occurred.</span><br/><span l10n=\"\">The traveller details are saved as manually entered</span></p></div><div class=modal-footer><button class=\"btn btn-kt\" ng-click=$close() l10n=\"\">Ok</button></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/travellers/adult/save-traveller-profile-error-message.html
// module id = 3357
// module chunks = 0